import axios from 'axios';
import { sortBy } from 'lodash';

import type { Site, Team, TeamDetailsWithLatLong, TeamDetailsWithLatLongReqBody } from '@sine/sine-core-api-types';
import type { TeamWithRoles } from '@sine/team-membership-api-types';

const teamService = {
  /**
   * @deprecated To fetch teams information use TMA `getAllMyTeams`
   * This entry is gonna be deleted in next release
   */
  async getMyTeams() {
    const { data } = await axios.get<Array<Team>>(`${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/team/my-teams`);
    return data;
  },

  async getAllMyTeams() {
    const { data } = await axios.get<Array<TeamWithRoles>>(
      `${window.env.REACT_APP_SINE_TEAM_MEMBERSHIP_API_ENDPOINT}/role/my-teams`,
    );

    return data.map((t) => ({
      id: t.teamId,
      name: t.teamName,
      roles: t.teamRoles,
    }));
  },

  async listAll() {
    const { data } = await axios.get<{ teams: Array<Team> }>(`${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/team/all`);
    return data;
  },

  async listSites(teamId: string) {
    const { data } = await axios.get<Array<Site>>(
      `${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/team/${teamId}/sites`,
    );

    return sortBy(data, 'name');
  },

  async updateTeam(teamId: string, values: { name: string }) {
    const { data } = await axios.post<Team>(
      `${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/team/${teamId}/details`,
      values,
    );
    return data;
  },

  async deleteTeam(teamId: string) {
    await axios.delete<never>(`${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/team/${teamId}`);
  },

  async getTeamMeta() {
    const { data } = await axios.get<TeamDetailsWithLatLong>(
      `${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/team/team-meta`,
    );
    return data;
  },

  async updateTeamMeta(values: TeamDetailsWithLatLongReqBody) {
    const { data } = await axios.post<TeamDetailsWithLatLong>(
      `${window.env.REACT_APP_SINE_CORE_API_ENDPOINT}/team/team-meta/update`,
      values,
    );
    return data;
  },
};

export default teamService;
